import { CardType } from 'types/deck'

import styles from './foilSquare.module.scss'

type Props = {
  card: CardType
  includeLabel?: boolean
}

const FoilSquare = ({ card, includeLabel }: Props) => {
  if (!includeLabel) return <span className={`${styles.finishes} ${card.modifier !== 'Normal' && styles.foil}`} />

  return (
    <span className={styles.gap}>
      <span className={`${styles.finishes} ${card.modifier !== 'Normal' && styles.foil}`} />{' '}
      {card.modifier !== 'Normal' ? card.modifier : ''}
    </span>
  )
}

export default FoilSquare
